import { makeStyles } from '@mui/styles';
import colors from 'global/styles/colors';
import { blueGrey } from '@mui/material/colors';

export const useStyles = makeStyles((theme) => ({
  roomBtn: {
    width: 250,
    margin: '0 auto',
  },
  root: {
    backgroundColor: colors.blue,
    borderRadius: 4,
  },
  input: {
    color: colors.white,
    '&::placeholder': {
      color: colors.white,
      opacity: 1,
    },
  },
  highlightContainer: {
    backgroundColor: blueGrey[50],
    borderRadius: 6,
    border: '2px solid black',
    transition: 'background-color 0.3s ease',
  },
  doneRoomsRow: {
    backgroundColor: theme.palette.grey[300],
    padding: 10,
    width: `calc(100% + 25px)`,
    position: 'relative',
    left: -24,
  },
  container: {
    position: 'relative',
    padding: `${theme.spacing(4)} 0px`,
    width: '80%',
    maxWidth: 600,
    margin: '0 auto',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      width: 'inherit',
      margin: 0,
    },
  },
  tagButton: {
    color: theme.colors.blue,
    borderColor: theme.colors.blue,
  },
  topBottomSpacing: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  tagRemove: {
    color: theme.colors.danger,
    borderColor: theme.colors.danger,
  },
  doubleIcon: {
    position: 'relative',
    height: 24,
  },
  plusIcon: {
    position: 'absolute',
    top: 12,
    right: -2,
    fontSize: 14,
  },
  formContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: 600,
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  gridItem: {
    width: 120,
    height: 120,
    position: 'relative',
    backgroundColor: 'rgba(0,0,0,0.2)',
    margin: `0px ${theme.spacing(1)} ${theme.spacing(1)} 0px`,
  },
  gridText: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0,0,0,0.2)',
    color: theme.colors.white,
    padding: 3,
  },
  toggleLabel: {
    top: -21,
    left: -14,
    fontSize: 12,
    color: theme.palette.secondary.main,
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
  },
  toggleFormControl: {
    paddingTop: 20,
    width: '100%',

    '& .jbuilderGroup': {
      '& .jbuilderCol': {
        flex: 1,

        '& .jbuilderErrorText': {
          color: theme.palette.error.main,
        },

        '& .MuiFormControl-root': {
          width: '100%',

          '& .MuiInputBase-root': {
            height: 56,
          },
        },
      },
    },
  },
}));

export default useStyles;
